// 本地兜底翻译；线上翻译走 CDN（MTS），需在 MTS 后台补齐 Fund.WireCurrencyNotSupported
export const Fund = {
    WireCurrencyNotSupported:
        "This account's currency is not supported for withdrawal. Please choose another account or add a wire transfer account in USD, GBP or EUR.",
};
